import CustomModal from "../CustomModal";

const DeleteStaffModal = ({
  isOpen,
  onRequestClose,
  selectedAdmin,
  handleDeleteAdmin,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Delete Admin Modal"
      className="delete-modal"
    >
      {selectedAdmin && (
        <div className="delete-modal-inner">
          <img
            src={`${process.env.PUBLIC_URL}/images/delete-danger.png`}
            alt="Warning icon"
          />
          <p>Are you sure you want to delete this Staff profile?</p>
          <div className="delete-modal-button">
            <button className="delete-btn1" onClick={handleDeleteAdmin}>
              Delete
            </button>
            <button className="delete-btn2" onClick={onRequestClose}>
              Back
            </button>
          </div>
        </div>
      )}
    </CustomModal>
  );
};

export default DeleteStaffModal;
